import FacebookSVG from "@design-system/ui-icons/vanilla/Facebook"
import { createIcon } from "../createIcon"

export const FacebookIcon = createIcon(FacebookSVG)
